module.exports = __webpack_public_path__ + "static/media/registerLockGuide2.0a3fb7bf.png";